module.exports = "/static-assets/_next/static/images/home-97ef721c9e40d9bb3da91b7d60903bf7.png";